<template>
  <div class="greatness-within-exercise">

    <Instructions v-if="currentStep === 1" />

    <RoleModels v-if="currentStep === 2" />

    <CharacterTraits v-if="currentStep === 3" />

    <Reflection v-if="currentStep === 4" />

  </div>
</template>

<script>
import pdfGenerator from "./pdfGenerator.vue";
import Instructions from "./Instructions.vue";
import RoleModels from "./RoleModels.vue";
import CharacterTraits from "./CharacterTraits.vue";
import Reflection from "./Reflection.vue";

export default {
  components: {Reflection, CharacterTraits, RoleModels, pdfGenerator, Instructions},
  props:      {},

  data() {
    return {
      workStarted:              0,
      currentStep:              1,
      roleModels:               [{id: window.crypto.randomUUID(), name:"", traits:[""]}],
    };
  },
  mounted() {
    // console.log("GreatnessWithin.vue mounted");
  },
  methods:  {
    nextStep() {
      this.currentStep++;
    },
    previousStep() {
      this.currentStep--;
    }
  }
}
</script>
